import './cookies.scss';

const Cookies = () => {
    return (
        <div className="cookies">
            <h1>Cookies</h1>
      <p>
        Файлы cookies представляют собой файл с передаваемой информацией на сайте, и данный файл хранится на устройстве пользователя. Содержание Cookies не позволяет идентифицировать пользователя и соответственно не доступны другие файлы на устройстве пользователя. Cookies может включать в себя наименование сайта, дату, время и т.д., ему присваивается уникальный номер, по которому его распознает пользователь.
      </p>
      <p>
        Сохраненные cookies позволяют распознать компьютер клиента, таким образом клиенту, при повторном посещении сайта или его раздела, предоставляется возможность избежать повторного ввода данных. Cookies улучшает опыт пользователя на сайте и используется, чтобы помочь развивать сайт и создать его более удобным для пользователей, чтобы помочь определить и понять ожидания пользователей, а также показать определенные рекламные объявления на различных сайтах соответствующей целевой аудитории, на основании предыдущих посещений сайта.
      </p>
      <p>
        Пользователь услуги может в любое время внести изменения в настройках, в отношении cookies. Данные настройки можно поменять, включить/блокировать автоматическую обработку cookies.
      </p>
      <h2>Больше информации о Cookies:</h2>
      <ul>
      <li>
        Cookies хранятся в вашем браузере, файлы временно хранятся в устройстве, устройство по истечению соответствующего времени автоматически стирает их.
      </li>
      <br />
      <li>Cookies хранятся в вашем браузере, файлы временно хранятся в устройстве до момента, когда пользователь их мануально удалит.</li>
      <br />
        <li>
          Аналитики Cookies и рекламные файлы с серверов объявлений, их компаний и поставщиков услуг, данные файлы адаптируются к пользователю, его предпочтениям и привычкам. Данные файлы позволяют оценить эффективность рекламы, например, вы можно узнать, как много людей нажали на определенную рекламу и посетили сайт рекламодателя. Эти файлы cookies собирают информацию и отправляют ее третьим лицам. Например, Google Ads, Google Analytics, который хранит файлы cookies в течение 26 месяцев, а затем автоматически удаляет их. Для получения дополнительной информации посетите сайты третьих лиц, получив больше дополнительной информации об использовании файлов cookies.
        </li>
        <br />
        </ul>
        <p>Информация о том, как посетители могут отказаться от Google используемых Cookies файлов, рекламных предпочтений Google или отказаться от третьих сторон поставщиков услуг, используемых Cookies файлы, страница отказа инициативной рекламной сети.
        </p>
        <p>
            Cookies файлы на данном сайте можно легко принять или отклонить: согласен / не согласен с использованием файлов cookies.
        </p>
        <p>
            Обратите внимание, что используемые файлы cookies, не могут нанести вред Вашему устройству. Для лучшего опыта пользователей и полноценной деятельности сайта мы рекомендуем сохранять файлы cookies, в таком случае есть возможность полноценно использовать доступное содержание и персонализированные функции сайта.
        </p>
        </div>
    )
}

export default Cookies;